import authService from './authService';
import { ensureOk, readList, toQuery } from './apiResponse';
import type { AppNotification } from '../types/planning';

class NotificationService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /notifications?unread=1 (até 50, não lidas primeiro) */
  async getAll(unreadOnly = false): Promise<AppNotification[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/notifications${toQuery({ unread: unreadOnly ? 1 : undefined })}`);
    return readList<AppNotification>(response, 'Falha ao buscar os alertas');
  }

  /** POST /notifications/:id/read */
  async markRead(id: number): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.post(`/notifications/${id}/read`);
    await ensureOk(response, 'Falha ao marcar o alerta como lido');
  }

  /** POST /notifications/read-all */
  async markAllRead(): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.post('/notifications/read-all');
    await ensureOk(response, 'Falha ao marcar os alertas como lidos');
  }
}

export const notificationService = new NotificationService();
export default notificationService;
